// Browser-safe event emitter used by new order components.
class SimpleEmitter {
  constructor() {
    this.listeners = new Map();
  }

  addListener(eventName, callback) {
    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, new Set());
    }
    this.listeners.get(eventName).add(callback);
    return this;
  }

  on(eventName, callback) {
    return this.addListener(eventName, callback);
  }

  removeListener(eventName, callback) {
    const set = this.listeners.get(eventName);
    if (!set) {
      return this;
    }

    set.delete(callback);
    if (set.size === 0) {
      this.listeners.delete(eventName);
    }
    return this;
  }

  off(eventName, callback) {
    return this.removeListener(eventName, callback);
  }

  emit(eventName, payload) {
    const set = this.listeners.get(eventName);
    if (!set) {
      return false;
    }

    set.forEach((callback) => {
      try {
        callback(payload);
      } catch (error) {
        // Keep emitter resilient so one listener doesn't block others.
        console.error("NoticeEmitter listener error:", error);
      }
    });

    return set.size > 0;
  }
}

const NoticeEmitter = new SimpleEmitter();

export default NoticeEmitter;
